import { render, staticRenderFns } from "./BCEmergencyInformationEmergency.vue?vue&type=template&id=de676a0a&scoped=true"
import script from "./BCEmergencyInformationEmergency.vue?vue&type=script&lang=js"
export * from "./BCEmergencyInformationEmergency.vue?vue&type=script&lang=js"
import style0 from "./BCEmergencyInformationEmergency.vue?vue&type=style&index=0&id=de676a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de676a0a",
  null
  
)

export default component.exports